'use client';

import { PropsWithChildren, useTransition } from 'react';
import clsx from 'clsx';

export function TransitionButton({
  disabled,
  className,
  type,
  onClick,
  children,
}: PropsWithChildren<{
  disabled?: boolean;
  className?: string;
  type?: 'submit' | 'reset' | 'button';
  onClick: () => void;
}>) {
  const [isPending, startTransition] = useTransition();

  return (
    <button
      type={type}
      className={clsx('relative transition-all', className)}
      disabled={isPending || disabled}
      aria-disabled={isPending || disabled}
      onClick={() => {
        startTransition(() => onClick());
      }}
    >
      {isPending && (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="loading loading-spinner" />
        </div>
      )}
      <span className={clsx('transition-all', isPending ? 'opacity-0' : 'opacity-100')}>
        {children}
      </span>
    </button>
  );
}
